import { getNotificationState } from 'common/header/notifications/hooks/mappers/impl/shared';
import {
  type MappedNotification,
  type NotificationMapper,
  type NotificationMapperOptions
} from 'common/header/notifications/Notifications.types';

export const globalIdRunMapper: NotificationMapper = (notification, options) => {
  return {
    ...notification,
    ...getTitle(notification, options),
    to: `/${options.tenantCode}/settings/tenants/global-id`
  };
};

function getTitle(
  notification: MappedNotification,
  options: NotificationMapperOptions
): Pick<MappedNotification, 'title' | 'description' | 'iconType'> {
  const state = getNotificationState(notification.status);

  if (state.isError) {
    return {
      title: options.intl.globalIdFailureTitle,
      description: '',
      iconType: 'FAILURE'
    };
  }
  if (state.isReady) {
    return {
      title: options.intl.globalIdSuccessTitle,
      description: '',
      iconType: 'SUCCESS'
    };
  }

  return {
    title: options.intl.globalIdInProgressTitle,
    description: '',
    iconType: 'INFO'
  };
}
